/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-target-blank */
import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { API_BASE, Palette } from "../../AppConfig";
import { get, fetchTimeout, toNumber, toAUD, GetRandomInt } from "../../components/Common";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DocumentFrameDialog from "./DocumentFrame_Dialog";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FrameAppBar from "./FrameAppBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Slide } from "@material-ui/core";
import BOMFrame from "../main_drawer/BOMFrame";
import Drawings, { checkCondition } from "./Drawings";
import BSL_Button from "../../components/BSL_Button";
import { engineeringPassed } from "../../redux_store/jobState_Validation";
import Message from "../../components/Message";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";
import { convertJobStateToIni } from "../../components/Common_Conversions";

const dialogstyles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        background: Palette.FieldersBlue,
        color: "white",
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(dialogstyles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="static" {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                    props.value
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    bom: {
        position: "fixed",
        zIndex: "10001",
        left: "0px",
        top: "0px",
        height: "100%",
        width: "100%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "white",
    },
    drawing: {
        position: "fixed",
        zIndex: "10001",
        right: "0px",
        top: "0px",
        height: "100%",
        width: "45%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "#9a9a9a",
        flexDirection: "column",
    },
    animatedItem: {
        animation: `$myEffect 300ms ${theme.transitions.easing.easeInOut}`,
    },
    animatedItem2: {
        animation: `$myEffect2 300ms ${theme.transitions.easing.easeInOut}`,
    },
    animatedItemExiting: {
        animation: `$myEffectExit 300ms ${theme.transitions.easing.easeInOut}`,
        opacity: 0,
        transform: "translateX(-200%)",
    },
    "@keyframes myEffect": {
        "0%": {
            opacity: 0,
            transform: "translateX(-200%)",
        },
        "100%": {
            opacity: 1,
            transform: "translateX(0)",
        },
    },
    "@keyframes myEffectExit": {
        "0%": {
            opacity: 1,
            transform: "translateX(0)",
        },
        "100%": {
            opacity: 0,
            transform: "translateX(-200%)",
        },
    },
    "@keyframes myEffect2": {
        "0%": {
            opacity: 0,
            transform: "translateX(200%)",
        },
        "100%": {
            opacity: 1,
            transform: "translateX(0)",
        },
    },
}));

function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export default (props) => {
    const { toggleDocumentOpen, updateDocumentData, DOCUMENT_TO_SHOW, generatingDocument } = props;

    const classes = useStyles();
    const user = useSelector((state) => state.app.user);
    const app = useSelector((state) => state.app);
    const config = useSelector((state) => state.config);
    const job = useSelector((state) => state.job);
    const GENERATING_DOCUMENT_STATUS = useSelector((state) => state.app?.designer?.GENERATING_DOCUMENT_STATUS);
    const STATIC_DOCUMENTS = useSelector((state) => state.config?.static_documents);

    const [progress, setProgress] = useState(1);
    const [fastProgress, setFastProgress] = useState(1);
    const [serverProgress, setServerProgress] = useState(1);
    const [serverProgressText, setServerProgressText] = useState("");
    const [openPopper, setOpenPopper] = useState(false);
    const [loadingDrawing, setLoadingDrawing] = useState(false);
    const [documentType, setDocumentType] = useState(props.documentType ? props.documentType : "");
    const [selectedDrawing, setSelectedDrawing] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [openQuoteSummaryDialog, setOpenQuoteSummaryDialog] = useState(false);
    const [quoteSummayData, setQuoteSummayData] = useState("");
    const [checked, setChecked] = useState({});
    const [bomOpen, setBomOpen] = useState(false);
    const [loadedDrawings, setLoadedDrawings] = useState(false);
    const [appendPDF, setAppendPDF] = useState({});
    const [bondorDwg, setBondorDwg] = useState({
        visible: false,
        link: "https://solarspan.com.au/wp-content/uploads/SolarSpan-InsulRoof-Patio-Design-Install-Guide-v7-1.pdf",
    });
    const [bubbleSetup, setBubbleSetup] = useState(false);
    const [staticDocs, setStaticDocs] = useState({});
    const frameRef = useRef(null);
    const { engValid, engValidNoOverride, engOverride } = engineeringPassed({ job });

    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const louvreMode = job?.DesignParameters?.LouvreMode === 1;

    const jobRef = useRef(job);

    useEffect(() => {
        // Ref is required to prevent closure on old job value in ToggleBomOpen when called from BOMFrame
        jobRef.current = job;
    }, [job]);

    // This can be removed once bondor drawings have been
    // updated and added to drawing register.
    useEffect(() => {
        if (appendPDF && Object.keys(appendPDF)?.length > 0) {
            let bondor = Object.keys(appendPDF).includes("BONDORDWG");
            if (bondor) {
                // Remove Bondor drawing from list of drawings
                setAppendPDF((current) => {
                    const { BONDORDWG, ...rest } = current;
                    return rest;
                });

                // Update link to drawing to visible
                setBondorDwg({ ...bondorDwg, visible: true });
            } else {
                // Update link to drawing to invisible
                setBondorDwg({ ...bondorDwg, visible: false });
            }
        }
    }, [appendPDF]);

    useEffect(() => {
        const timer = setInterval(() => {
            let minInt = 3;
            let maxInt = 4;

            setServerProgress((prevProgress) => (prevProgress >= 98 ? 99 : prevProgress + 0.5));

            area_factor = 500 * (job.AreaSpecifications.length - 1);
            setProgress((prevProgress) =>
                prevProgress >= 80
                    ? prevProgress >= 96
                        ? 99
                        : prevProgress + randomIntFromInterval(minInt, minInt + 2)
                    : prevProgress + randomIntFromInterval(maxInt, maxInt + 3)
            );
        }, randomIntFromInterval(1100 + area_factor, 1500 + area_factor));
        return () => {
            clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if (!engValid && !engOverride) {
            // Delay setting the state for 5 seconds
            const timeoutId = setTimeout(() => {
                setShowMessage({
                    type: "warning",
                    message: "🏗️ Some documents have been disabled until the design passes engineering.",
                });
            }, 1000); // 1000 milliseconds (1 seconds) - to allow slider to position

            // Cleanup the timeout in case the component unmounts or the dependency changes
            return () => clearTimeout(timeoutId);
        }
    }, [engValid]);

    useEffect(() => {
        const timer2 = setInterval(() => {
            let minInt = 3;
            let maxInt = 4;
            area_factor = 300 * (job.AreaSpecifications.length - 1);
            setFastProgress((prevFastProgress) =>
                prevFastProgress >= 80
                    ? prevFastProgress >= 96
                        ? 99
                        : prevFastProgress + randomIntFromInterval(minInt, minInt + 2)
                    : prevFastProgress + randomIntFromInterval(maxInt, maxInt + 3)
            );
        }, randomIntFromInterval(400 + area_factor, 600 + area_factor));
        return () => {
            clearInterval(timer2);
        };
    }, []);

    useEffect(() => {
        if (loadedDrawings) {
            setLoadedDrawings(false);
            LoadDrawings(job);
        }
    }, [loadedDrawings]);

    useEffect(() => {
        if (loadingDrawing) toggleBomOpen();
    }, [loadingDrawing]);

    useEffect(() => {
        if (GENERATING_DOCUMENT_STATUS) {
            let split = GENERATING_DOCUMENT_STATUS.split(",");
            if (split[0].startsWith("+")) {
                setServerProgress((prevProgress) => (prevProgress += toNumber(split[0])));
                setServerProgressText(split[1]);
            } else {
                setServerProgress((prevProgress) => {
                    let newVal = toNumber(split[0]);
                    if (newVal > prevProgress) return newVal;
                    else return (prevProgress += 1);
                });
                setServerProgressText(split[1]);
            }
        }
    }, [GENERATING_DOCUMENT_STATUS]);

    useEffect(() => {
        if (!STATIC_DOCUMENTS) return;

        const clonedDocs = window.structuredClone(STATIC_DOCUMENTS);

        const updatedDocs = Object.fromEntries(
            Object.entries(clonedDocs).map(([category, documents]) => {
                let showCategory = false;

                const updatedDocuments = Object.fromEntries(
                    Object.entries(documents || {}).map(([documentName, documentDetails]) => {
                        const display = documentDetails.Conditions
                            ? checkCondition({ Conditions: documentDetails.Conditions }, job)
                            : true;

                        if (display) showCategory = true;

                        return [documentName, { ...documentDetails, display }];
                    })
                );

                return [category, { ...updatedDocuments, display: showCategory }];
            })
        );

        setStaticDocs(updatedDocs);
    }, [STATIC_DOCUMENTS, job]);

    const checkDocumentToShow = (document_type) => {
        setDocumentType(document_type);
        setOpenPopper(true);
    };

    const generateDocumentToShow = (document_type) => {
        let UPDATE_BOM = false;
        setLoadingDrawing(false);
        if (document_type === "Order List") UPDATE_BOM = true;
        if (document_type === "Council Report") UPDATE_BOM = true;

        let system_items = job?.QuoteParameters?.BOM?.SystemList;
        let order_items = job?.QuoteParameters?.BOM?.OrderList;
        if (document_type === "Production Layouts" && !system_items?.total_eprice && !order_items?.total_eprice) {
            UPDATE_BOM = true;
        }

        if (UPDATE_BOM) {
            setBomOpen(true);
            return;
        }

        setProgress(1);
        setFastProgress(1);
        setServerProgress(1);
        updateDocumentData(job, document_type);
    };

    const setDocumentToShow = (document) => {
        props.updateDesigner("GENERATING_DOCUMENT", false);
        props.updateDesigner("DOCUMENT_TO_SHOW", document);
    };

    const loadData = () => {};

    const handleDialogSelectorClose = (document) => {
        setOpenPopper(false);
        if (document === null) {
        } else if (document === "") {
            generateDocumentToShow(documentType);
        } else {
            setDocumentToShow(document);
        }
    };

    const downloadEngineering = () => {
        var element = document.createElement("a");
        element.setAttribute("href", document_to_show_url + DOCUMENT_TO_SHOW.replace("pdf", "engineering.zip"));
        element.setAttribute("download", DOCUMENT_TO_SHOW.replace("pdf", "engineering.zip"));

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();
    };

    const showQuoteDetails = () => {
        setOpenQuoteSummaryDialog(true);
        setQuoteSummayData("loading...");

        fetchTimeout(document_to_show_url + DOCUMENT_TO_SHOW.replace("pdf", "order.json"), {
            method: "GET",
        })
            .then(async (response) => {
                let text = await response.text();
                let order_data = JSON.parse(text);
                let data_summary = [];

                if (user.Role > 0)
                    data_summary.push(
                        <div key="total">
                            <strong>Total Supply Price:</strong> {toAUD(order_data.total_eprice)} (ex GST) + Packing and
                            Del
                        </div>
                    );
                if (user.Role > 0) data_summary.push(<hr />);
                data_summary.push(
                    <div key="materials">
                        <strong>Materials:</strong>
                    </div>
                );

                let system_items = job?.QuoteParameters?.BOM?.SystemList;
                let errors = [];

                if (system_items.price_error_summary && system_items.price_error_summary !== "") {
                    var splitted = system_items.price_error_summary.split("\n");
                    splitted.forEach((item) => {
                        errors.push(item);
                    });
                }

                for (var index in order_data["summary"]) {
                    let item = order_data["summary"][index];
                    var errorflag = false;

                    for (var errorindex in errors) {
                        if (errorflag === false) {
                            if (errors[errorindex].includes(item.Code)) {
                                data_summary.push(
                                    <div key={index + item.Desc}>
                                        <div style={{ color: "red" }}>
                                            {item.Qty} x {item.Desc}{" "}
                                            {toNumber(item.Length) > 0 ? " @" + toNumber(item.Length) + "mm" : ""}{" "}
                                            {item.Colour ? "(" + item.Colour + ")" : ""}
                                        </div>
                                    </div>
                                );
                                errorflag = true;
                            }
                        }
                    }

                    if (errorflag === false) {
                        data_summary.push(
                            <div key={index + item.Desc}>
                                {item.Qty} x {item.Desc}{" "}
                                {toNumber(item.Length) > 0 ? " @" + toNumber(item.Length) + "mm" : ""}{" "}
                                {item.Colour ? "(" + item.Colour + ")" : ""}
                            </div>
                        );
                    }
                }

                setQuoteSummayData(data_summary);
            })
            .catch((e) => {
                setQuoteSummayData("error loading list...");
            });
    };
    const handleCloseQuoteSummaryDialog = () => {
        setOpenQuoteSummaryDialog(false);
    };

    function bubbleIframeMouseMove(iframe) {
        // Save any previous onmousemove handler
        var existingOnMouseMove = iframe.contentWindow.onmousemove;

        // Attach a new onmousemove listener
        iframe.contentWindow.onmousemove = function (e) {
            // Fire any existing onmousemove listener
            if (existingOnMouseMove) existingOnMouseMove(e);

            // Create a new event for the this window
            var evt = document.createEvent("MouseEvents");

            // We'll need this to offset the mouse move appropriately
            var boundingClientRect = iframe.getBoundingClientRect();

            // Initialize the event, copying exiting event values
            // for the most part
            evt.initMouseEvent(
                "mousemove",
                true, // bubbles
                false, // not cancelable
                window,
                e.detail,
                e.screenX,
                e.screenY,
                e.clientX + boundingClientRect.left,
                e.clientY + boundingClientRect.top,
                e.ctrlKey,
                e.altKey,
                e.shiftKey,
                e.metaKey,
                e.button,
                null // no related element
            );

            // Dispatch the mousemove event on the iframe element
            iframe.dispatchEvent(evt);
        };

        // Save any previous onmousemove handler
        var existingOnMouseUp = iframe.contentWindow.onmouseup;

        // Attach a new onmousemove listener
        iframe.contentWindow.onmouseup = function (e) {
            // Fire any existing onmousemove listener
            if (existingOnMouseMove) existingOnMouseUp(e);

            // Create a new event for the this window
            var evt = document.createEvent("MouseEvents");

            // We'll need this to offset the mouse move appropriately
            var boundingClientRect = iframe.getBoundingClientRect();

            // Initialize the event, copying exiting event values
            // for the most part
            evt.initMouseEvent(
                "mouseup",
                true, // bubbles
                false, // not cancelable
                window,
                e.detail,
                e.screenX,
                e.screenY,
                e.clientX + boundingClientRect.left,
                e.clientY + boundingClientRect.top,
                e.ctrlKey,
                e.altKey,
                e.shiftKey,
                e.metaKey,
                e.button,
                null // no related element
            );

            // Dispatch the mousemove event on the iframe element
            iframe.dispatchEvent(evt);
        };
    }

    const drawingSelection = () => {
        setLoadingDrawing(true);
    };

    if (frameRef && frameRef.current && !bubbleSetup) {
        setBubbleSetup(true);
        bubbleIframeMouseMove(frameRef.current);
    }

    const LoadDrawings = (job) => {
        if (job?.QuoteParameters?.BOM?.QuoteData) {
            // Render list from drawing numbers
            const drawings = Drawings(job, config, true, user.Role);

            let addKeys = {};
            Object.keys(drawings).map((key, val) => {
                addKeys[key] = key.includes("Internal •") ? false : true;
            });
            addKeys["select"] = true;
            setChecked(addKeys);

            // Sort drawings (after 1000) to be ordered
            const sortedDrawings = Object.entries(drawings)
                .sort((aEntry, bEntry) => {
                    const [a, b] = [aEntry[1], bEntry[1]];

                    // Extract drawing numbers
                    const extractDrawingNumber = (drawing) => {
                        const numPart = typeof drawing === "object" ? drawing[0] : drawing;
                        return parseInt(numPart.split(".pdf")[0]);
                    };

                    const drawingNum1 = extractDrawingNumber(a);
                    const drawingNum2 = extractDrawingNumber(b);

                    // Compare and sort
                    if (drawingNum1 > 1000 && drawingNum2 > 1000) {
                        return drawingNum1 - drawingNum2;
                    } else if (drawingNum1 > 1000) {
                        return 1;
                    } else if (drawingNum2 > 1000) {
                        return -1;
                    }

                    return 0;
                })
                .reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

            if (loadingDrawing) setAppendPDF(sortedDrawings);
            return sortedDrawings;
        } else {
            setLoadingDrawing(false);
        }
    };

    const toggleBomOpen = async (saved = false, closeFrame = false) => {
        const bomWasOpen = bomOpen;
        const currentJob = jobRef.current;
        setBomOpen(!bomOpen);

        if (bomWasOpen && saved && !loadingDrawing && !closeFrame) {
            setProgress(1);
            setFastProgress(1);
            setServerProgress(1);
            setServerProgressText("");
            updateDocumentData(currentJob, documentType);
        }

        if (bomWasOpen && loadingDrawing) {
            setLoadedDrawings(true);
        }
    };

    const GetDXF = async () => {
        const job_data = job;
        // let api_url = API_BASE() + "document/" + job_data.id + "/" + "DXF";
        let api_url = API_BASE() + "svg/" + job_data.id + "/selection";

        let user_id = app.user.id;
        let job_ini = convertJobStateToIni(job_data, app, "", config);
        let material_list = job_data?.QuoteParameters?.BOM?.OrderList;
        if (!material_list || !material_list?.items) material_list = job_data?.QuoteParameters?.BOM?.SystemList;

        let request_id = Date.now() + "_" + GetRandomInt(1000, 9999);

        return fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    document_type: "DXF",
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    order_list: material_list,
                    wind_data: job_data?.SiteParameters?.WindData,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                    job_raw: job_data,
                    request_id: request_id,
                    session_id: window?.session_id,
                    business_code: job_data?.BusinessCode,
                    threed: false,
                }),
            },
            120000
        )
            .then(async (response) => {
                if (response?.status && response.status >= 200 && response.status <= 300) {
                    let filename = await response.text();

                    let document_to_show_url = API_BASE() + "document/" + job.id + "/";

                    var element = document.createElement("a");
                    element.setAttribute("href", document_to_show_url + filename);
                    element.setAttribute("download", filename);

                    element.style.display = "none";
                    document.body.appendChild(element);

                    element.click();
                } else {
                    throw {
                        message: "Could not generate DXF at this time. Please wait a moment and try again.",
                    };
                }
                toggleDocumentOpen();
            })
            .catch((e) => {
                toggleDocumentOpen();
                if (window.dispatch)
                    window.dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: "Error getting DXF - " + e?.message,
                    });
            });
    };

    var area_factor = 300 * (job?.AreaSpecifications?.length ? job?.AreaSpecifications?.length - 1 : 0);

    let document_to_show_url = API_BASE() + "document/" + job.id + "/";

    let quick_spinner = true;
    if (generatingDocument === "Council Report") quick_spinner = false;
    if (generatingDocument === "Production Layouts") quick_spinner = false;
    if (generatingDocument === "Quote Layout") quick_spinner = true;

    let export_documents_role_access = config?.role_access?.designer?.export_dxf ?? 90;

    return (
        <Paper
            elevation={20}
            style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", textAlign: "center" }}
        >
            {documentType !== "Quote Layout" && (
                <FrameAppBar
                    title=""
                    onClick={toggleDocumentOpen}
                    button2Text={
                        DOCUMENT_TO_SHOW &&
                        (documentType === "Council Report" || documentType === "Production Layouts") &&
                        user.Role > 90
                            ? "Get Engineering"
                            : false
                    }
                    button2Click={
                        DOCUMENT_TO_SHOW &&
                        (documentType === "Council Report" || documentType === "Production Layouts") &&
                        user.Role > 90
                            ? () => downloadEngineering()
                            : false
                    }
                    button1Text={DOCUMENT_TO_SHOW ? "Back" : false}
                    button1Click={DOCUMENT_TO_SHOW ? () => setDocumentToShow(false) : false}
                />
            )}
            {documentType === "Quote Layout" && (
                <FrameAppBar
                    title=""
                    onClick={toggleDocumentOpen}
                    button2Text={DOCUMENT_TO_SHOW && user.Role > 91 ? "Get Engineering" : false}
                    button2Click={DOCUMENT_TO_SHOW && user.Role > 91 ? () => downloadEngineering() : false}
                    button1Text={DOCUMENT_TO_SHOW ? "Show Quote Details" : false}
                    button1Click={DOCUMENT_TO_SHOW ? () => showQuoteDetails() : false}
                />
            )}
            {generatingDocument && !DOCUMENT_TO_SHOW && !GENERATING_DOCUMENT_STATUS && (
                <div style={{ overflow: "auto", width: "400px", padding: "20px", marginTop: "200px" }}>
                    {quick_spinner ? (
                        <CircularProgressWithLabel value={fastProgress} />
                    ) : (
                        <CircularProgressWithLabel value={progress} />
                    )}
                    <br />
                    <Typography variant="overline" gutterBottom>
                        generating {generatingDocument}...
                    </Typography>
                </div>
            )}
            {generatingDocument && GENERATING_DOCUMENT_STATUS && (
                <div style={{ overflow: "auto", width: "400px", padding: "20px", marginTop: "200px" }}>
                    <CircularProgressWithLabel value={serverProgress} />
                    <br />
                    <Typography variant="overline" gutterBottom>
                        {serverProgressText}...
                    </Typography>
                </div>
            )}
            {DOCUMENT_TO_SHOW && (
                <iframe
                    ref={frameRef}
                    title="DOCUMENT"
                    name="DOCUMENT"
                    src={
                        DOCUMENT_TO_SHOW.startsWith("http") || DOCUMENT_TO_SHOW.includes("api/")
                            ? DOCUMENT_TO_SHOW
                            : document_to_show_url + DOCUMENT_TO_SHOW
                    }
                    style={{ width: "100%", flex: 5 }}
                    onLoad={loadData}
                ></iframe>
            )}

            {!DOCUMENT_TO_SHOW &&
                !generatingDocument &&
                (appendPDF && Object.keys(appendPDF)?.length > 0 ? (
                    <div
                        className={classes.animatedItem}
                        style={{ overflow: "auto", width: "400px", padding: "52px 20px 20px 20px" }}
                    >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" gutterBottom>
                                DRAWINGS
                            </Typography>
                            <div>
                                <FormControlLabel
                                    style={{ display: "flex" }}
                                    label="Select All"
                                    control={
                                        <Checkbox
                                            checked={checked["select"]}
                                            onChange={() => {
                                                let newChecked = {};
                                                Object.keys(checked).map((key, val) => {
                                                    newChecked[key] = !checked["select"];
                                                });
                                                setChecked(newChecked);
                                            }}
                                        />
                                    }
                                />
                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                    {Object.keys(appendPDF)?.map((key) => (
                                        <div
                                            key={key}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                margin: "2px",
                                                textAlign: "start",
                                            }}
                                        >
                                            <Checkbox
                                                checked={checked[key]}
                                                onChange={() => setChecked({ ...checked, [key]: !checked[key] })}
                                            />

                                            <span
                                                title="View Drawing"
                                                style={{
                                                    margin: "auto 0px",
                                                    paddingTop: "5px",
                                                    cursor: "pointer",
                                                    color: "#00009c",
                                                    textDecoration: "underline",
                                                    "&:hover": {
                                                        color: "#3030AC",
                                                        cursor: "pointer",
                                                    },
                                                }}
                                                onClick={(e) => {
                                                    setSelectedDrawing(appendPDF[key].split(".")[0]);
                                                }}
                                            >
                                                {key}
                                            </span>
                                        </div>
                                    ))}
                                </Box>
                            </div>

                            <Button
                                style={{ margin: "4px" }}
                                variant="contained"
                                onClick={() => {
                                    let drawingsToShow = "";
                                    setSelectedDrawing(null);
                                    for (var key in appendPDF) {
                                        if (checked[key]) {
                                            const drawingNumbers = Array.isArray(appendPDF[key])
                                                ? appendPDF[key].map((drawing) => drawing.split(".")[0]).join("|")
                                                : appendPDF[key].split(".")[0]; // handle array of drawings
                                            if (drawingsToShow === "") {
                                                drawingsToShow += drawingNumbers;
                                            } else {
                                                drawingsToShow += "|" + drawingNumbers;
                                            }
                                        }
                                    }

                                    if (drawingsToShow.includes("|")) {
                                        setDocumentToShow(API_BASE() + "document/" + job.id + "/" + drawingsToShow);
                                    } else {
                                        setDocumentToShow(API_BASE() + "document/drawing/" + drawingsToShow + ".pdf");
                                    }
                                }}
                            >
                                Generate Drawings
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div style={{ overflow: "auto", width: "400px", padding: "52px 20px 20px 20px" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {!carportMode && !louvreMode && (
                                <>
                                    <Typography variant="h6" gutterBottom>
                                        INDIVIDUAL DOCUMENTS
                                    </Typography>
                                    <Button variant="contained" onClick={() => checkDocumentToShow("Quote Layout")}>
                                        Generated Quote Layouts
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Job Summary Layouts")}
                                    >
                                        Job Summary
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Plan View Layouts")}
                                    >
                                        Plan View Layout
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Elevations and Isometrics Layouts")}
                                    >
                                        Elevations and Isometrics
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Engineering Documentation")}
                                        disabled={!engValid && !engOverride}
                                    >
                                        Engineering Report
                                    </Button>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Footing Layouts")}
                                    >
                                        Footing Layout
                                    </Button>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={toggleBomOpen}
                                    >
                                        Component List
                                    </Button>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Order List")}
                                    >
                                        Order Material List
                                    </Button>

                                    <Button variant="contained" onClick={() => drawingSelection()}>
                                        Construction Drawings
                                    </Button>
                                </>
                            )}
                            {carportMode && user.Role >= 90 && (
                                <>
                                    <Typography variant="h6" gutterBottom>
                                        INDIVIDUAL DOCUMENTS
                                    </Typography>
                                    <Button variant="contained" onClick={() => checkDocumentToShow("Quote Layout")}>
                                        Generated Quote Layouts
                                    </Button>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Order List")}
                                    >
                                        Order Material List
                                    </Button>
                                </>
                            )}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" gutterBottom style={{ marginTop: "6px" }}>
                                MULTIPLE PAGE REPORTS
                            </Typography>
                            {!carportMode && !louvreMode && (
                                <>
                                    <Button
                                        style={{ width: "100%" }}
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Council Report")}
                                    >
                                        Council Report
                                    </Button>

                                    {user.Role >= 90 && (
                                        <Button
                                            disabled={!engValid && !engOverride}
                                            variant="contained"
                                            onClick={() => checkDocumentToShow("Production Layouts")}
                                        >
                                            Production Layouts
                                        </Button>
                                    )}
                                </>
                            )}

                            {carportMode && (
                                <>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Job Summary Layouts")}
                                    >
                                        National Carport Documents
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Elevations and Isometrics Layouts")}
                                    >
                                        Elevations and Isometrics
                                    </Button>
                                </>
                            )}
                            {louvreMode && (
                                <>
                                    <Button variant="contained" onClick={() => checkDocumentToShow("Quote Layout")}>
                                        Generated Quote Layouts
                                    </Button>
                                    <Button
                                        disabled={!engValid && !engOverride}
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Council Report")}
                                    >
                                        Louvreroof Council Documents
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => checkDocumentToShow("Elevations and Isometrics Layouts")}
                                    >
                                        Elevations and Isometrics
                                    </Button>
                                </>
                            )}
                        </div>

                        {export_documents_role_access && (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Typography variant="h6" gutterBottom style={{ marginTop: "6px" }}>
                                    EXPORT FILES
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        GetDXF();
                                    }}
                                >
                                    Export DXF (CAD / Autodesk)
                                </Button>
                            </div>
                        )}

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {staticDocs &&
                                Object.entries(staticDocs).map(([key, value]) => {
                                    if (value?.display === false) return;

                                    return (
                                        <div>
                                            <Typography variant="h6" gutterBottom style={{ marginTop: "6px" }}>
                                                {key}
                                            </Typography>
                                            {Object.entries(value).map(([doc_key, doc_value]) => {
                                                if (doc_key === "display" || doc_value?.display === false) return;

                                                let url = doc_value;
                                                let style = { backgroundColor: "#c8d9e1" };

                                                if (typeof doc_value === "object") {
                                                    url = doc_value?.url;
                                                    if (doc_value?.style) style = { ...style, ...doc_value.style };
                                                }

                                                return (
                                                    <a
                                                        href={url}
                                                        style={{
                                                            font: null,
                                                            textDecoration: "inherit",
                                                            color: null,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        <Button variant="contained" style={style}>
                                                            {doc_key}
                                                        </Button>
                                                    </a>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                ))}
            <div style={{ width: "4px", background: "#CCC", cursor: "e-resize" }}></div>
            <DocumentFrameDialog
                jobId={job?.id}
                open={openPopper}
                documentType={documentType}
                documentName={
                    carportMode && documentType === "Job Summary Layouts"
                        ? "Carport Document Pack"
                        : louvreMode && documentType === "Job Summary Layouts"
                        ? "Louvreroof Document Pack"
                        : documentType
                }
                onClose={handleDialogSelectorClose}
            />

            <Dialog
                onClose={handleCloseQuoteSummaryDialog}
                aria-labelledby="customized-dialog-title"
                open={openQuoteSummaryDialog}
                style={{ zIndex: "10000 !important" }}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleCloseQuoteSummaryDialog}>
                    Quote Data Material List
                </DialogTitle>
                <DialogContent dividers>{quoteSummayData}</DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCloseQuoteSummaryDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {bomOpen && (
                <Slide direction="right" in={bomOpen} mountOnEnter unmountOnExit>
                    <div className={classes.bom}>
                        <BOMFrame
                            toggleBomOpen={toggleBomOpen}
                            confirmButton={documentType || loadingDrawing ? "Confirm and Generate" : false}
                            engValid={engValidNoOverride}
                        />
                    </div>
                </Slide>
            )}

            <Slide
                style={{ transition: "all 0.3s ease-in-out !important" }}
                direction="left"
                in={selectedDrawing}
                mountOnEnter
                unmountOnExit
            >
                <div className={classes.drawing}>
                    <BSL_Button
                        style={{ backgroundColor: "gray" }}
                        onClick={(e) => {
                            setSelectedDrawing(null);
                        }}
                    >
                        <CloseIcon />
                    </BSL_Button>

                    <iframe
                        ref={frameRef}
                        title="DOCUMENT"
                        name="DOCUMENT"
                        src={`${API_BASE() + "document/"}/Drawing/${selectedDrawing}%7C`}
                        style={{ width: "100%", flex: 5 }}
                        onLoad={loadData}
                    ></iframe>
                </div>
            </Slide>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </Paper>
    );
};
